import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { FeatureFlag, type Features } from '@moko/utils/src/featureAccess';

export interface FeatureFlagRedirectProps {
  featureKey: Features;
  children: ReactNode;
  redirectTo?: string;
}

export const FeatureFlagRedirect = ({
  featureKey,
  children,
  redirectTo = '/',
}: FeatureFlagRedirectProps) => (
  <FeatureFlag
    featureKey={featureKey}
    fallback={<Navigate to={redirectTo} replace />}
  >
    {children}
  </FeatureFlag>
);
